import React from 'react'
import { Link } from 'react-router-dom'

import { Row, Col } from 'ui-kit/components/Grid'

import { useLangContext } from 'context/lang'
import { useDevice } from 'hooks/media'
import { useLang } from 'hooks/lang'
import routes from 'constants/routes'

import { NavBarWrapper, NavBarLogo, NavItem, NavBarLang } from './style'
import MailLink from '../MailLink'

const NavBar = ({ activeNav }) => {
  const isMobile = useDevice()
  const { lang, setLang } = useLangContext()
  const { translate: t } = useLang()

  const isProfileActive = activeNav === 'profile'
  const isDashboardActive = activeNav === 'dashboard'
  const isHistoryActive = activeNav === 'history'

  const HomeIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.33337 10.8284C3.33337 9.43781 3.33337 8.74254 3.61975 8.13502C3.90614 7.52749 4.44245 7.08503 5.51507 6.20012L6.18173 5.65011C8.00875 4.14282 8.92226 3.38917 10 3.38917C11.0778 3.38917 11.9913 4.14282 13.8183 5.65011L14.485 6.20012C15.5576 7.08503 16.0939 7.52749 16.3803 8.13502C16.6667 8.74254 16.6667 9.43781 16.6667 10.8283V14.0625C16.6667 14.4688 16.6667 14.672 16.6471 14.8429C16.4877 16.2281 15.3948 17.321 14.0096 17.4803C13.8387 17.5 13.6355 17.5 13.2292 17.5V17.5C13.0938 17.5 13.026 17.5 12.9691 17.4934C12.5073 17.4403 12.143 17.076 12.0899 16.6143C12.0834 16.5573 12.0834 16.4896 12.0834 16.3542V15C12.0834 14.9226 12.0834 14.8839 12.0823 14.8512C12.0478 13.798 11.202 12.9522 10.1488 12.9177C10.1161 12.9167 10.0774 12.9167 10 12.9167V12.9167C9.92267 12.9167 9.88398 12.9167 9.85127 12.9177C8.79804 12.9522 7.95226 13.798 7.91778 14.8512C7.91671 14.8839 7.91671 14.9226 7.91671 15V16.3542C7.91671 16.4896 7.91671 16.5573 7.91016 16.6143C7.85703 17.076 7.49275 17.4403 7.03099 17.4934C6.97404 17.5 6.90632 17.5 6.77087 17.5V17.5C6.36454 17.5 6.16138 17.5 5.99051 17.4803C4.60523 17.321 3.51239 16.2281 3.35303 14.8429C3.33337 14.672 3.33337 14.4688 3.33337 14.0625V10.8284Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )

  const HistoryIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5001 1.35001C4.93197 1.35001 2.8501 3.43188 2.8501 6.00001V14C2.8501 16.5681 4.93197 18.65 7.5001 18.65H12.5001C15.0682 18.65 17.1501 16.5681 17.1501 14V6.00001C17.1501 3.43188 15.0682 1.35001 12.5001 1.35001H7.5001ZM4.1501 6.00001C4.1501 4.14985 5.64994 2.65001 7.5001 2.65001H12.5001C14.3503 2.65001 15.8501 4.14985 15.8501 6.00001V14C15.8501 15.8502 14.3503 17.35 12.5001 17.35H7.5001C5.64994 17.35 4.1501 15.8502 4.1501 14V6.00001ZM7.08341 5.51669C6.72443 5.51669 6.43341 5.80771 6.43341 6.16669C6.43341 6.52568 6.72443 6.81669 7.08341 6.81669H12.5001C12.8591 6.81669 13.1501 6.52568 13.1501 6.16669C13.1501 5.80771 12.8591 5.51669 12.5001 5.51669H7.08341ZM6.43341 9.08335C6.43341 8.72436 6.72443 8.43335 7.08341 8.43335H12.5001C12.8591 8.43335 13.1501 8.72436 13.1501 9.08335C13.1501 9.44234 12.8591 9.73335 12.5001 9.73335H7.08341C6.72443 9.73335 6.43341 9.44234 6.43341 9.08335ZM7.08341 11.35C6.72443 11.35 6.43341 11.641 6.43341 12C6.43341 12.359 6.72443 12.65 7.08341 12.65H10.639C10.998 12.65 11.289 12.359 11.289 12C11.289 11.641 10.998 11.35 10.639 11.35H7.08341Z"
        fill="currentColor"
      />
    </svg>
  )

  const ProfileIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99966 1.3501H9.95022H9.95021C8.10667 1.35009 6.65676 1.35008 5.52432 1.50232C4.36307 1.65843 3.4388 1.98527 2.71213 2.71185L2.71172 2.71226C1.98515 3.43893 1.65831 4.3632 1.5022 5.52444C1.34995 6.65688 1.34996 8.10679 1.34998 9.95033V9.95034V9.99978V10.0492V10.0492C1.34996 11.8928 1.34995 13.3427 1.5022 14.4751C1.65831 15.6364 1.98515 16.5606 2.71172 17.2873L2.71213 17.2877C3.4388 18.0143 4.36307 18.3411 5.52432 18.4972C6.65677 18.6495 8.10668 18.6495 9.95024 18.6495H9.95026H9.99966H10.0491H10.0491C11.8926 18.6495 13.3426 18.6495 14.475 18.4972C15.6362 18.3411 16.5605 18.0143 17.2872 17.2877L17.2876 17.2873C18.0142 16.5606 18.341 15.6364 18.4971 14.4751C18.6494 13.3427 18.6494 11.8928 18.6493 10.0492V10.0492V9.99978V9.95038V9.95036C18.6494 8.1068 18.6494 6.65689 18.4971 5.52444C18.341 4.3632 18.0142 3.43893 17.2876 2.71226L17.2872 2.71185C16.5605 1.98527 15.6362 1.65843 14.475 1.50232C13.3426 1.35008 11.8927 1.35009 10.0491 1.3501H10.0491H9.99966ZM3.63132 3.63114C4.07619 3.18632 4.68042 2.92746 5.69753 2.79073C6.73333 2.65148 8.09582 2.6501 9.99966 2.6501C11.9035 2.6501 13.266 2.65148 14.3018 2.79073C15.3189 2.92746 15.9231 3.18632 16.368 3.63114L16.3683 3.63144C16.8131 4.07631 17.072 4.68055 17.2087 5.69765C17.348 6.73345 17.3493 8.09594 17.3493 9.99978C17.3493 11.9036 17.348 13.2661 17.2087 14.3019C17.072 15.319 16.8131 15.9233 16.3683 16.3681L16.368 16.3684C16.1684 16.568 15.9367 16.7302 15.65 16.8607V16.6501C15.65 14.5514 13.9486 12.8501 11.85 12.8501H8.14997C6.05128 12.8501 4.34997 14.5514 4.34997 16.6501V16.8609C4.06298 16.7304 3.83108 16.5682 3.63132 16.3684L3.63102 16.3681C3.1862 15.9233 2.92734 15.319 2.79061 14.3019C2.65136 13.2661 2.64998 11.9036 2.64998 9.99978C2.64998 8.09594 2.65136 6.73345 2.79061 5.69765C2.92734 4.68055 3.1862 4.07631 3.63102 3.63144L3.63132 3.63114ZM5.64997 17.2023C5.66572 17.2045 5.68157 17.2067 5.69753 17.2088C6.73333 17.3481 8.09582 17.3495 9.99966 17.3495C11.9035 17.3495 13.266 17.3481 14.3018 17.2088C14.318 17.2067 14.334 17.2045 14.35 17.2022V16.6501C14.35 15.2694 13.2307 14.1501 11.85 14.1501H8.14997C6.76925 14.1501 5.64997 15.2694 5.64997 16.6501V17.2023ZM9.99997 6.15008C8.84017 6.15008 7.89997 7.09029 7.89997 8.25008C7.89997 9.40988 8.84017 10.3501 9.99997 10.3501C11.1598 10.3501 12.1 9.40988 12.1 8.25008C12.1 7.09029 11.1598 6.15008 9.99997 6.15008ZM6.59997 8.25008C6.59997 6.37232 8.1222 4.85008 9.99997 4.85008C11.8777 4.85008 13.4 6.37232 13.4 8.25008C13.4 10.1279 11.8777 11.6501 9.99997 11.6501C8.1222 11.6501 6.59997 10.1279 6.59997 8.25008Z"
        fill="currentColor"
      />
    </svg>
  )

  const Logo = () => {
    return (
      <Link to={routes.main}>
        <NavBarLogo>{t('LOGO')}</NavBarLogo>
      </Link>
    )
  }

  const NavBarItem = ({ text, route, active, icon }) => {
    const currentRoute = active ? '#' : route
    return (
      <Link data-testid={active ? 'nav-link-selected' : 'nav-link'} to={currentRoute}>
        <NavItem data-testid={active ? 'nav-item-selected' : 'nav-item'} activeNav={active}>
          {icon}
          {text}
        </NavItem>
      </Link>
    )
  }

  const changeLang = (lang) => {
    setLang(lang)
  }

  const emailTooltipText = `${t('NAVBAR.EMAIL_TOOLTIP')}  ${process.env.REACT_APP_CS_EMAIL}`

  return (
    <NavBarWrapper data-testid="nav-bar">
      {!isMobile ? (
        <Row justifyContent="space-between">
          <Col>
            <Row m={-13} alignItems="center">
              <Col p={13}>
                <Logo />
              </Col>
              <Col p={13}>
                <NavBarItem
                  text={t('NAVBAR.DASHBOARD')}
                  route={routes.main}
                  active={isDashboardActive}
                  icon={<HomeIcon />}
                />
              </Col>
              <Col p={13}>
                <NavBarItem
                  text={t('NAVBAR.HISTORY')}
                  route={routes.history}
                  active={isHistoryActive}
                  icon={<HistoryIcon />}
                />
              </Col>
            </Row>
          </Col>
          <Col>
            <Row alignItems="center">
              <Col>
                {/* NOTE: temporary hidden */}
                {/* {Object.keys(locale).map((localeItem, index) => ( */}
                {[].map((localeItem, index) => (
                  <NavBarLang key={index} active={localeItem === lang} onClick={() => changeLang(localeItem)}>
                    {localeItem}
                  </NavBarLang>
                ))}
              </Col>
              <Col>
                <MailLink mailto={`mailto:${process.env.REACT_APP_CS_EMAIL}`} tooltipText={emailTooltipText} />
              </Col>
              <Col>
                <NavBarItem
                  text={t('NAVBAR.PROFILE')}
                  route={routes.profile}
                  active={isProfileActive}
                  icon={<ProfileIcon />}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      ) : (
        <Row justifyContent="center" m={-35}>
          <Col p={35}>
            <NavBarItem route={routes.main} active={isDashboardActive} icon={<HomeIcon />} />
          </Col>
          <Col p={35}>
            <NavBarItem route={routes.history} active={isHistoryActive} icon={<HistoryIcon />} />
          </Col>
          <Col p={35}>
            <NavBarItem route={routes.profile} active={isProfileActive} icon={<ProfileIcon />} />
          </Col>
        </Row>
      )}
    </NavBarWrapper>
  )
}

export default NavBar
